import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from 'react-redux';
import Summary from "./Summary";
import Header from "./Header";
import AppointmentDate from "./AppointmentDate";
import InterventionService from "../../services/Intervention";

import "./Intervention.css";
import {SpinnerModal} from "../../public/components/SpinnerModal";
import Fleetback from "./fleetback/Fleetback";
import ReceptionCard from "./reception/ReceptionCard";
import MobilityCard from "./mobility/MobilityCard";
import ConversationCard from "./conversation/ConversationCard";
import AttachmentsCard from "./AttachmentsCard";
import ServicesCardWrapper from "./services/ServicesCardWrapper";

class Intervention extends Component {

  constructor(props){
    super(props)
    const {match} = props;
    this.state = {id:parseInt(match.params.id, 10)};

  }
  componentDidMount() {
    const {match} = this.props;
    this.fetchData(match.params.id);
  }

  fetchData = (id)=>{
    this.props.dispatchFetchIntervention(id);
    this.props.dispatchFetchMainServices();
  }


  componentWillReceiveProps(nextProps){
    if(this.props.match.params.id != nextProps.match.params.id){
      this.fetchData(nextProps.match.params.id)
    }

  }

  render() {
    const {id} = this.state;
    const {fetchIntervention: {intervention, loading}, mainServices, history} = this.props;

    if (!intervention || id !== intervention.id){
      // if the id does not match, we need to wait for the request to be completed
      return <SpinnerModal visible={true}/>;
    }

    const canWrite = !InterventionService.hasEndStatus(intervention);

    return (
      <div>
        <SpinnerModal visible={loading}/>
        <Header history={history}/>

        <aside className="main__aside main__aside--fixed">
          <Summary intervention={intervention}/>
        </aside>

        <div className="main__content main__content--with-fixed-header">
            <div>
              <Fleetback />
              {intervention.journey && <ServicesCardWrapper intervention={intervention} canWrite={canWrite}/>}

              {!InterventionService.isWeb(intervention) && intervention.conversationId && <ConversationCard
                canWrite={!InterventionService.isArchived(intervention) && !InterventionService.isDeleted(intervention) && intervention.origin !== "CALL_CENTER"}/>}
              {intervention.journey && intervention.journey.type !== 'MESSAGE'  && <AttachmentsCard canWrite={canWrite} uuid={intervention.journey.uuid} connectedUserId={intervention.customer.id}/>}
              {InterventionService.isTypeAppointment(intervention) && intervention.journey.properties && intervention.journey.properties.mobility && <MobilityCard canWrite={canWrite} connectedUserId={intervention.customer.id} />}
              {intervention.journey && intervention.journey.properties && intervention.journey.properties.reception && <ReceptionCard canWrite={canWrite} mainServices={mainServices}/>}

              {intervention.startDate && <AppointmentDate canWrite={canWrite} mainServices={mainServices} intervention={intervention}/>}
            </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchIntervention: state.fetchIntervention,
  vin: state.fetchIntervention && state.fetchIntervention.intervention && state.fetchIntervention.intervention.vehicle.vin,
  mainServices: state.fetchMainServices.mainServices || {},
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchIntervention: (id) => {
    dispatch({type: 'FETCH.INTERVENTION.REQUEST', id});
    dispatch({type: 'FETCH.FLEETBACK_INTERVENTIONS.REQUEST', interventionId:id});
  },
  dispatchFetchMainServices: () => dispatch({type: 'FETCH_MAIN_SERVICES.REQUEST'})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Intervention))



// WEBPACK FOOTER //
// ./src/components/interventiondetail/Intervention.js